<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="primary" (click)="modalCtrl.dismiss()">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ "reservation-app.contact" | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="item-list">
  <ion-grid>
    <ion-item lines="none" *ngIf="groupApp" style="margin-top: 20px">
      <img
        alt="logo"
        style="height: 200px; margin: auto"
        alt="{{ groupApp.group }}"
        src="{{ rootDir }}{{ groupApp.group }}/logos/{{ selectedLogoFileName }}"
      />
    </ion-item>
    <ion-item lines="none">
      <ion-label style="font-weight: bold; font-size: 18px">
        {{ "reservation-app.stores" | translate }}
      </ion-label>
    </ion-item>
    <ion-item *ngFor="let store of stores">
      <ion-label *ngIf="store" style="margin-left: 5px" class="ion-text-wrap">
        <div style="font-weight: 700">
          {{
            store.store_name_mobileorder &&
            store.store_name_mobileorder[selectedLanguage]
              ? store.store_name_mobileorder[selectedLanguage]
              : store.store_name_langs &&
                store.store_name_langs[selectedLanguage]
              ? store.store_name_langs[selectedLanguage]
              : store.store_name_langs && store
              ? store.store_name_langs.el
              : store.store_name
          }}
        </div>
        <div
          style="display: flex; align-items: center"
          *ngIf="store && store.address"
        >
          <ion-icon
            (click)="openLink(store.mapCenterStoreLat, store.mapCenterStoreLng)"
            color="primary"
            name="location-sharp"
            style="font-size: 18px; margin-right: 8px; cursor: pointer"
          ></ion-icon>
          <ion-text style="font-size: small">
            {{ store.address }}
          </ion-text>
        </div>

        <div style="display: flex; align-items: center" *ngIf="store.telephone">
          <ion-icon
            (click)="callPhoneNumber(store.telephone)"
            src="assets/ionicons/call-sharp.svg"
            color="primary"
            style="font-size: 18px; margin-right: 8px; cursor: pointer"
          ></ion-icon>
          <span>{{ store.telephone }}</span>
        </div>

        <div
          style="display: flex; align-items: center"
          *ngIf="store.vatEmailStore"
        >
          <ion-icon
            color="primary"
            style="font-size: 18px; margin-right: 8px; cursor: default"
            size="small"
            name="mail"
          ></ion-icon>
          <span style="text-decoration: underline">{{
            store.vatEmailStore
          }}</span>
        </div>
      </ion-label>
      <ion-button fill="clear" (click)="openInfo(store)">
        <ion-icon
          slot="icon-only"
          name="information-circle-outline"
          size="small"
        ></ion-icon>
      </ion-button>
    </ion-item>
  </ion-grid>
</ion-content>
